<div class="discount-component-container page-root-container">
  <div class="page-header">
    <div class="page-title">
      <img class="icon" src="assets/images/menu/svg/discounts.svg"><span class="title">Discounts</span>
    </div>
    <div class="page-actions">
      @if(permission.can_add){
      <button mat-button color="primary" class="btn-add"
        (click)="addClicked()"><mat-icon>person_add</mat-icon>New</button>
      }
      @if(permission.can_export || permission.can_execute){

      <button mat-button color="accent" class="btn-export" (click)="exportClicked()" [disabled]="IsDownloading">
        <img class="download-icon"
          [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
        Export
      </button>
      }
    </div>
  </div>

  <div class="data-container ">
    <app-loader [show]="isLoading"></app-loader>

    <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]" [filter]="filter"
      (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)" [hidePageSize]="true">
    </app-search-filter>

    <section tabindex="0" class="table-container">
      <table matSort mat-table [dataSource]="dataSource">
        <!-- Column Definitions -->
        <ng-container matColumnDef="item">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="item" [attr.rowspan]="2" class="item-header">
            #
          </th>
          <td mat-cell *matCellDef="let discount; let i = index" class="item-column">
            {{ pagingData.pageIndex * pagingData.pageSize + i + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="code">
          <th mat-sort-header="code" mat-header-cell *matHeaderCellDef [attr.rowspan]="2" style="width: 80px">
            Code
          </th>
          <td mat-cell *matCellDef="let discount" style="width: 80px">
            {{ discount.code }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-sort-header="name" mat-header-cell *matHeaderCellDef [attr.rowspan]="2">
            Name
          </th>
          <td mat-cell *matCellDef="let discount">{{ discount.name }}</td>
        </ng-container>

        <!-- Discount Group Header (spans 2 columns) -->
        <ng-container matColumnDef="discountGroup">
          <th mat-header-cell *matHeaderCellDef colspan="2"
            style="text-align: center; width: 180px; padding-right: 28px">
            Discount
          </th>
        </ng-container>

        <!-- Discount Sub-columns -->
        <ng-container matColumnDef="discountAmount">
          <th mat-sort-header="price" mat-header-cell *matHeaderCellDef class="status-header">
            Amount
          </th>
          <td mat-cell *matCellDef="let discount" style="text-align: right; padding-right: 28px">
            <span *ngIf="discount.is_percentage === 0">
              {{ discount.price | currency }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="discountPercentage">
          <th mat-sort-header="price" mat-header-cell *matHeaderCellDef class="status-header">
            Percentage
          </th>
          <td mat-cell *matCellDef="let discount" style="text-align: right; padding-right: 28px">
            <span *ngIf="discount.is_percentage === 1">
              {{ discount.price }}%
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="is_item_specific">
          <th mat-sort-header="is_item_specific" mat-header-cell *matHeaderCellDef [attr.rowspan]="2" class="center-column" style="width: 140px">
            Item Specific
          </th>
          <td mat-cell *matCellDef="let discount" class="center-column">
            @if (discount.is_item_specific == 1) {
            <span style="font-size: 20px">✔</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="is_overridable">
          <th mat-sort-header="is_overridable" mat-header-cell *matHeaderCellDef [attr.rowspan]="2" class="center-column" style="width: 100px">
            Overridable
          </th>
          <td mat-cell *matCellDef="let discount" class="center-column">
            @if (discount.is_overridable == 1) {
            <span style="font-size: 20px">✔</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="valid">
          <th mat-sort-header="is_valid" mat-header-cell *matHeaderCellDef [attr.rowspan]="2" class="center-column" style="width: 120px">
            Valid
          </th>
          <td mat-cell *matCellDef="let discount" class="center-column">
            @if (discount.is_valid == 1) {
            <span style="display: inline-block; padding: 4px 10px; font-size: 12px; font-weight: 500; border-radius: 12px; background-color: #e6f7ed; color: #1f8b4c;">Valid</span>
            } @else {
            <span style="display: inline-block; padding: 4px 10px; font-size: 12px; font-weight: 500; border-radius: 12px; background-color: #fde8e8; color: #c81e1e;">Invalid</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="action" stickyEnd>
          <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2"></th>
          <td mat-cell class="row-menu-btn" style="width: 50px" *matCellDef="let rowItem">
            <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu"
              (click)="onRowSelected(rowItem); $event.stopPropagation()">
              <mat-icon>more_vert</mat-icon>
            </a>
            <mat-menu #rowMenu>
              @if(permissionService.getRowPermission(permission,rowItem.id).can_delete){
              <button mat-menu-item (click)="onDelete(rowItem)">Delete</button>
              }
              @if(permissionService.getRowPermission(permission,rowItem.id).can_edit){
              <button mat-menu-item (click)="onEdit(rowItem)">Edit</button>
              }@else{
              <button mat-menu-item (click)="onEdit(rowItem)">View</button>
              }
            </mat-menu>
          </td>
        </ng-container>

        <!-- Header Rows -->
        <tr mat-header-row *matHeaderRowDef="topHeaderRow; sticky: true"></tr>
        <tr mat-header-row *matHeaderRowDef="subHeaderRow; sticky: true"></tr>

        <!-- Data Rows -->
        <tr mat-row class="table-element-row" *matRowDef="let discount; columns: displayedColumns"
          (click)="onRowSelected(discount)" (dblclick)="onEdit(discount)"
          [ngClass]="{ 'row-selected': discount.id === selectedItem?.id }"></tr>
      </table>
    </section>


    @if(pagingData.length<=0){ <div class="no-data-container">
      <img src="assets/images/no-data.png">
      <span class="no-data-info">No data found. Please remove or redefine the filters if
        any.</span>
  </div>
  }
</div>

</div>